import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers, compose, branch, renderNothing } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Clearfix,
  Modal,
} from 'react-bootstrap';

import { connect } from 'react-redux';
import { submitMyForm } from '../actions';

import TicketUploadItem, { getTicketUploadSubmissionForm } from './TicketUploadItem';
import { queryTicketDocumentGQL } from '../graphql';

export const uploadSubmissionItemModalPropTypes = {
  showSubmissionItemModal: PropTypes.bool.isRequired,
  openUploadSubmissionItemModal: PropTypes.func.isRequired,
  closeUploadSubmissionItemModal: PropTypes.func.isRequired,
};

export const withUploadSubmissionItemModalState = withStateHandlers(
  (props) => { return { showSubmissionItemModal: false }; },
  {
    openUploadSubmissionItemModal: (state, props) => {
      return () => { return { showSubmissionItemModal: true }; };
    },
    closeUploadSubmissionItemModal: (state, props) => {
      return () => { return { showSubmissionItemModal: false }; };
    },
  },
);

const formSelectorPropTypes = {
  ticketUploadSubmissionForm: PropTypes.object.isRequired,
  submitMyFormAction: PropTypes.func.isRequired,
};

const propTypes = exact({
  documentId: PropTypes.number.isRequired,
  ticketId: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  ticketUploadSubmissionForm: PropTypes.object.isRequired,
  ...formSelectorPropTypes,
});

const TicketUploadSubmissionModal = (props) => {
  const { show, onHide, ticketId, documentId } = props;

  const {
    ticketUploadSubmissionForm, submitMyFormAction,
  } = props;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Replace Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TicketUploadItem />
        <p>
          Replacing a ticket will only replace the first page of the ticket.
        </p>
        <Clearfix>
          <ButtonToolbar className="pull-right">
            <Button
              bsStyle="warning"
              onClick={onHide}
            >
              Cancel
            </Button>
            <Button
              bsStyle="primary"
              type="submit"
              disabled={
                // FIXME: re-evaluate this logic
                ticketUploadSubmissionForm.invalid
                || (!ticketUploadSubmissionForm.invalid && ticketUploadSubmissionForm.submitting)
              }
              onClick={async () => {
                await submitMyFormAction(
                  ticketUploadSubmissionForm.values,
                  documentId,
                  ticketId,
                  0,
                );
                onHide();
              }}
            >
              Submit
            </Button>
          </ButtonToolbar>
        </Clearfix>
      </Modal.Body>
    </Modal>
  );
};

TicketUploadSubmissionModal.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    ticketUploadSubmissionForm: getTicketUploadSubmissionForm(state),
  };
};

const mapDispatchToProps = {
  submitMyFormAction: submitMyForm,
};

const withNoDocumentId = branch(
  (props) => {
    return (props.documentId === null);
  },
  renderNothing,
);

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  queryTicketDocumentGQL,
  withNoDocumentId,
);

export default enhance(TicketUploadSubmissionModal);
